import React, { createContext } from 'react';

export const Context = createContext<{
    topSectionDivRef: React.MutableRefObject<undefined>;
    mainHolderDivRef?: React.MutableRefObject<undefined>;
}>({
    topSectionDivRef: undefined,
    mainHolderDivRef: undefined,
});
